import { render, staticRenderFns } from "./PDFInitPageSelect.vue?vue&type=template&id=c35f54da&"
import script from "./PDFInitPageSelect.vue?vue&type=script&lang=js&"
export * from "./PDFInitPageSelect.vue?vue&type=script&lang=js&"
import style0 from "./PDFInitPageSelect.vue?vue&type=style&index=0&id=c35f54da&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports